<template>
  <div>
    <el-card shadow="always">
      <el-page-header
        v-if="id === ''"
        @back="back"
        title
        :content="$t('adicionar-novo-filial')"
      ></el-page-header>
      <el-page-header
        v-if="id !== ''"
        @back="back"
        title
        :content="$t('atualizar-filial')"
      ></el-page-header>
    </el-card>
    <el-card>
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-position="top"
        :status-icon="true"
        :rules="rules"
        :inline-message="true"
      >
        <el-row :gutter="5">
          <el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="6">
            <el-form-item :label="$t('nome-fantasia')" prop="name">
              <el-input ref="name" v-model="ruleForm.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="18" :md="18" :lg="18" :xl="18">
            <el-form-item :label="$t('razao-social')" prop="companyname">
              <el-input
                ref="companyname"
                v-model="ruleForm.companyname"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="12" :md="12" :lg="4" :xl="4">
            <el-form-item
              :label="$t('cpf/cnpj')"
              prop="federalid"
              class="is-required"
            >
              <el-input
                v-model="ruleForm.federalid"
                v-mask="['NNN.NNN.NNN-NN', 'NN.NNN.NNN/NNNN-##']"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="14" :sm="6" :md="6" :lg="3" :xl="3">
            <el-form-item :label="$t('cep')" prop="cep" class="is-required">
              <el-input
                maxlength="9"
                v-model="ruleForm.cep"
                v-mask="'#####-###'"
                @blur="zipcode()"
              >
                <el-button
                  slot="append"
                  icon="el-icon-map-location"
                ></el-button>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="14" :sm="6" :md="6" :lg="3" :xl="3"> </el-col>
        </el-row>
        <el-form-item :label="$t('endereco')" prop="address">
          <el-input v-model="ruleForm.address"></el-input>
        </el-form-item>
        <el-row :gutter="5">
          <el-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3">
            <el-form-item :label="$t('bairro')" prop="neighborhood">
              <el-input v-model="ruleForm.neighborhood"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="9" :sm="9" :md="9" :lg="6" :xl="6">
            <el-form-item :label="$t('cidade')" prop="city">
              <el-input v-model="ruleForm.city"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="3" :sm="3" :md="3" :lg="2" :xl="2">
            <el-form-item :label="$t('estado')" prop="state">
              <el-input v-model="ruleForm.state"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="14" :sm="6" :md="6" :lg="3" :xl="3">
            <el-form-item :label="$t('numero')" prop="number">
              <el-input
                type="number"
                maxlength="6"
                v-model="ruleForm.number"
                v-mask="'######'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="18" :md="18" :lg="12" :xl="12">
            <el-form-item :label="$t('complemento')" prop="extent">
              <el-input v-model="ruleForm.extent"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
            <el-form-item prop="billetExclusive">
              <el-checkbox v-model="ruleForm.billetExclusive">
                Gerar um boleto separado para essa filial
              </el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
        <br />
        <el-form-item style="text-align: center">
          <el-button
            type="warning"
            v-if="id === ''"
            autofocus
            @click="submitForm('ruleForm')"
            >{{ $t("adicionar") }}</el-button
          >
          <el-button
            type="warning"
            v-if="id !== ''"
            autofocus
            @click="editForm('ruleForm')"
            >{{ $t("atualizar") }}</el-button
          >
          <el-button type="danger" @click="back()">{{
            $t("voltar")
          }}</el-button>
        </el-form-item>
        <br />
        <el-tabs v-model="activeTab">
          <el-tab-pane label="Serviços" name="services">
            <el-table
              :data="listServices"
              stripe
              ref="tableServices"
              style="width: 100%"
              :default-sort="{ prop: 'name', order: 'ascending' }"
            >
              <el-table-column
                sortable
                prop="servicegroup"
                :label="$t('grupo-servico')"
                :filters="filterGroup"
                :filter-method="filterHandler"
              > 
                <template slot-scope="scope">{{
                  scope.row.servicegroup ? scope.row.servicegroup.name : ''
                }}</template>
              </el-table-column>
              <el-table-column
                sortable
                prop="code"
                :label="$t('codigo')"
              ></el-table-column>
              <el-table-column
                sortable
                prop="name"
                :label="$t('nome')"
              ></el-table-column>
              <el-table-column
                sortable
                prop="postoffice"
                :label="`${$t('correio')}?`"
              >
                <template slot-scope="scope">{{
                  scope.row.postoffice ? $t("sim") : $t("nao")
                }}</template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </el-form>
    </el-card>
  </div>
</template> 
<script>
import { CpfHelpers } from "@/xpost/helpers/cpf";
import { CnpjHelpers } from "@/xpost/helpers/cnpj";
import { i18n } from "@/plugin/i18n";
import ZipMixins from "../../../mixins/zipcode";
import FederalId from "@/xpost/components/FederalId";
import { UserService } from "@/services/users/user.services";
import { ServicesService } from "@/services/customers/services.services";
import { CustomerService } from "@/services/customers/customers.services";

export default {
  name: "BranchAdd",
  mixins: [ZipMixins],
  components: {
    FederalId,
  },
  data() {
    var checkFederalid = (rule, value, callback) => {
      if (value.length == 14) {
        CpfHelpers.checkCpf(rule, value, callback);
      } else if (value.length == 18) {
        CnpjHelpers.checkCnpj(rule, value, callback);
      }
      return callback();
    };
    return {
      id: "",
      activeTab: "services",
      user: {
        type: "2",
      },
      listServices: [],
      ruleForm: {
       name: "",
        companyname: "",
        federalid: "",
        cep: "",
        zipcode: "",
        number: "",
        extent: "",
        address: "",
        city: "",
        billetExclusive: false,
        neighborhood: "",
        state: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: i18n.tc("nome-fantasia-obrigatorio"),
            trigger: "blur",
          },
        ],
        companyname: [
          {
            required: true,
            message: i18n.tc("razao-social-obrigatorio"),
            trigger: "blur",
          },
        ],
        zipcode: [
          {
            required: true,
            message: i18n.tc("cep-obrigatorio"),
            trigger: "blur",
          },
        ],
        federalId: {
          validator: checkFederalid,
          trigger: "blur",
        },
      },
    };
  },
  methods: {
    back() {
      var vm = this;
      vm.$router.replace({ name: "branch" });
    },
    validate() {
      const vm = this;
      const group = {};
      for (const row of vm.$refs.tableServices.selection) {
        // Agrupa pelo CÓDIGO do grupo: grupos distintos podem exibir o mesmo nome
        const name = row.servicegroupCode || (row.servicegroup && row.servicegroup.code) || row.servicegroup || "Não definido";
        if (group[name]) {
          return false;
        }
        group[name] = true;
      }
      return false;
    },
    fetchRecords() {
      const vm = this;
      ServicesService.list()
        .then((response) => {
          vm.listServices = response.records;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        });
    },

    get() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      CustomerService.get(vm.id)
        .then((response) => {
          vm.ruleForm = response;
          vm.ruleForm.federalid = response.federalid;
          vm.ruleForm.city = response.zipcode.city;
          vm.ruleForm.address = response.zipcode.address;
          vm.ruleForm.neighborhood = response.zipcode.neighborhood;
          vm.ruleForm.cep = response.zipcode.zipcode;
          vm.ruleForm.state = response.zipcode.state;
          vm.listServices = response.service;
          vm.ruleForm.billetExclusive = response.billetExclusive;
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    editForm(formName) {
      const vm = this;
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = vm.$loading(vm.$options.loading);
          CustomerService.branch(
            vm.id,
            vm.ruleForm,
          )
            .then((response) => {
              this.$message({
                type: "success",
                message: i18n.tc("filial-atualizado-sucesso"),
              });
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    filterHandler(value, row, column) {
      const property = column["property"];
      if (row[property]) {
        return row[property] === value;
      } else {
        return value === "Não definido";
      }
    },
  },
  computed: {
    filterGroup() {
      const vm = this;
      const list = [];
      for (const row of vm.listServices) {
        const group = row.servicegroup || "Não definido";
        if (!list.find((x) => x.value === group)) {
          list.push({
            text: group,
            value: group,
          });
        }
      }
      return list;
    },
  },
  mounted() {
    const vm = this;
    //vm.fetchRecords();
    UserService.me()
      .then((response) => {
        vm.user.type = response.type;
        if (this.$route.params.id) {
          this.id = this.$route.params.id;
          vm.get();
        } else {
          vm.$refs.companyname.$el.children[0].focus();
        }
      })
  },
};
</script>
<style scoped>
.el-page-header__left {
  display: flex !important;
}
form {
  margin-top: 20px;
}
@media screen and (min-width: 458px) {
  .col-form-label {
    text-align: right;
  }
}
</style>
